import { render, staticRenderFns } from "./EventBuyTickets.vue?vue&type=template&id=b3a8023e&scoped=true&"
import script from "./EventBuyTickets.vue?vue&type=script&lang=js&"
export * from "./EventBuyTickets.vue?vue&type=script&lang=js&"
import style0 from "./EventBuyTickets.vue?vue&type=style&index=0&id=b3a8023e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a8023e",
  null
  
)

export default component.exports